import angular from 'angular';

angular.module('cloudX').directive('cxPushShareholderInfoEstoxButton', [
  '$q',
  '$http',
  'appUrls',
  '$filter',
  '$translate',
  'flySvc',
  'ModalService',
  'dataCache',
  function($q, $http, appUrls, $filter, $translate, flySvc, ModalService, dataCache) {
    return {
      restrict: 'E',
      scope: {
        relation: '=',
        gmType: '=',
      },
      template: `<div ng-show="estoxEnabled" class="margin10T" style="display:flex;flex-wrap:wrap;justify-content: space-between;">
                <a ng-click="!retrievingModel && retrieveModel();$event.stopPropagation()"
                    class=" btn btn-default btn-xs margin5B"
                    ng-disabled="retrievingModel"
                    title="{{('Create the company and its shareholder information in eStox'|translate)}}">
                  <i ng-if="!retrievingModel" class="fa fa-plus"></i>
                  <i ng-if="retrievingModel" class="fa fa-spin fa-spinner "></i>
                  <span data-translate="Create {relationName} in eStox"
                        data-translate-values="{relationName:relationName}"></span>
                </a>
                <a ng-click="!retrievingFromEstox && retrieveFromEstox();$event.stopPropagation()"
                    ng-disabled="retrievingFromEstox"
                    class="btn btn-default btn-xs margin5B"
                    title="{{('Retrieve shareholder information from eStox'|translate)}}">
                  <i ng-if="!retrievingFromEstox" class="fa fa-refresh"></i>
                  <i ng-if="retrievingFromEstox" class="fa fa-spin fa-spinner "></i>
                  <span data-translate="Retrieve info from eStox"
                        data-translate-values="{relationName:relationName}"></span>
                </a></div>`,
      require: ['^cxRelationFile'],
      link: function($scope, element, attrs, ctrl) {
        var cxRelFile = ctrl[0];

        const searchProviders = dataCache.getArray('relationSearchProviders');
        $scope.estoxEnabled = searchProviders.some(x => x === 2); // external relation provider 2 is estox

        $scope.relationName = $scope.relation
          ? $filter('relationName')($scope.relation)
          : $translate.instant('Company');

        $scope.retrieveModel = function() {
          if ($scope.relation && $scope.relation.id) {
            const relationId = $scope.relation.id;
            $scope.retrievingModel = true;
            return $http.post(appUrls.api + '/api/relation/GetEstoxModel?id=' + relationId).then(
              function({ data }) {
                $scope.retrievingModel = false;
                if (!data) return;
                return ModalService.showModal({
                  template: require('../../relations/dialogs/estoxConfirmationDialog.html'),
                  controller: 'EstoxConfirmationDialogCtrl',
                  controllerAs: 'vm',
                  locationChangeSuccess: false,
                  inputs: {
                    data,
                  },
                }).then(function(modal) {
                  modal.element.modal();
                  modal.element.on('hidden.bs.modal', function(e) {
                    modal.element.off(e); //Remove event
                    modal.element.remove(); //Remove element
                  });
                  modal.close.then(function(result) {
                    if (!result) return;
                  });
                });
              },
              function(error) {
                $scope.retrievingModel = false;
                flySvc.error(error.data.code, error.data.parameters);
                return '';
              },
            );
          }
        };

        $scope.retrieveFromEstox = function() {
          if ($scope.relation && $scope.relation.id) {
            const relationId = $scope.relation.id;
            $scope.retrievingFromEstox = true;
            $http.post(appUrls.api + '/api/relation/RetrieveFromEstox?id=' + relationId).then(
              function(result) {
                $scope.retrievingFromEstox = false;
                flySvc.success('SuccessTitle');
                if (cxRelFile && cxRelFile.refreshOpenSections) cxRelFile.refreshOpenSections();
              },
              function(error) {
                $scope.retrievingFromEstox = false;
                flySvc.error(error);
              },
            );
          }
        };
      },
    };
  },
]);
